import { RootState } from "./types";

export const isUserSignupFailed = (state: RootState) =>
  state.signUp.signedUpFailure;

export const isUserSignupSucceed = (state: RootState) =>
  state.signUp.signedUpSuccess;

export const isUserSigninFailed = (state: RootState) =>
  state.signIn.signedInFailure;

export const isUserSigninSucceed = (state: RootState) =>
  state.signIn.signedInSuccess;

export const getNotifications = (state: RootState) =>
  state.notification.notifications;

export const getConversations = (state: RootState) =>
  state.conversation.conversations;
